import React from "react";

import {
  BarsMiniIcon,
  BoxIcon,
  ClockIcon,
  GearIcon,
  InfoIcon,
  PathIcon,
  PulseMiniIcon,
  UserGroupIcon,
} from "../../lib/icons";
import { startCase } from "../../lib/utils";

const ICONS = {
  "My Leads": UserGroupIcon,
  "Follow-ups": ClockIcon,
  "Lead Journey": PathIcon,
  "My Agents": UserGroupIcon,
  Reports: BarsMiniIcon,
  Dashboard: PulseMiniIcon,
  "CRM Admin": GearIcon,
  Inventory: BoxIcon,
  Support: InfoIcon,

};

function Sidebar({
  activeSidebarItem,
  currentUser,
  roleScope,
  summary,
  workspaceItems,
  managementItems,
  onItemClick,
  setIsAdmin,
  showAgentWorkspace,
}) {
  const availabilityLabel = currentUser.availability_status === "break" && currentUser.break_reason
    ? `Break: ${startCase(currentUser.break_reason)}`
    : startCase(currentUser.availability_status || "online");

  return (
    <aside className="sidebar">
      <div>
        <section className="sidebar-section">
          <p className="sidebar-title">Workspace</p>
          <div className="sidebar-items">
            {workspaceItems.map((label) => {
              const Icon = ICONS[label] || UserGroupIcon;
              const badge = label === "Follow-ups" && summary.followUpsCount ? summary.followUpsCount : null;

              return (
                <button
                  key={label}
                  type="button"
                  className={`sidebar-item ${activeSidebarItem === label ? "active" : ""}`}
                  onClick={() => onItemClick(label)}
                >
                  <span className="sidebar-item-label">
                    <Icon />
                    <span>{label}</span>
                  </span>
                  {badge ? <span className="sidebar-badge">{badge}</span> : null}
                </button>
              );
            })}
          </div>
        </section>

        {managementItems.length ? (
          <section className="sidebar-section management">
            <p className="sidebar-title">Management</p>
            <div className="sidebar-items">
              {managementItems.map((label) => {
                const Icon = ICONS[label] || GearIcon;
                return (
                  <button
                    key={label}
                    type="button"
                    className={`sidebar-item ${activeSidebarItem === label ? "active" : ""}`}
                    onClick={() => onItemClick(label)}
                  >
                    <span className="sidebar-item-label">
                      <Icon />
                      <span>{label}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </section>
        ) : null}
        {showAgentWorkspace ? (
          <button
            key="Agent Workspace"
            type="button"
            className={`sidebar-item ${activeSidebarItem === "admin" ? "active" : ""}`}
            onClick={() => setIsAdmin(true)}
          >
            <span className="sidebar-item-label">
              <span>Agent Workspace</span>
            </span>
          </button>
        ) : null}
      </div>



      <div className="sidebar-user-card">
        <span className="avatar-badge large">
          {currentUser.full_name
            .split(" ")
            .map((part) => part[0])
            .join("")
            .slice(0, 2)
            .toUpperCase()}
        </span>
        <div>
          <p className="sidebar-user-name">{currentUser.full_name}</p>
          <p className="sidebar-user-meta">
            {roleScope?.label} · {availabilityLabel}
          </p>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
